const Input = ({ label, name, value, onChange, type = "text", className, isRequired = false, readOnly=false,note=false }) => {
    return (
        <div className={`col-md-2 ${className ? className: ""}`}>
            <label className="form-label fw-semibold small">
                {label}
                {isRequired && <span className="required">*</span>}
            </label>
            <input
                readOnly={readOnly}
                type={type}
                className="form-control"
                name={name}
                value={type === "file" ? undefined : value}
                onChange={onChange}
                {...(type === "file" ? {} : { value })}
            />
            {note && <span className="form-text text-muted">
                {note}
             </span>}
        </div>
    )
}

export default Input;